if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');

        this.fixedBar = null;
        this.fixedBtn = null;
        this._io = null;
        this._submitMo = null;
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this._initFixedAtc();

        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();

          this._syncFixedCta();
          this._observeSubmit();
          this._attachIO();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this._io) this._io.disconnect();
        if (this._submitMo) this._submitMo.disconnect();
        this._io = null;
        this._submitMo = null;
        if (this.fixedBar && this.fixedBar.parentNode) this.fixedBar.parentNode.removeChild(this.fixedBar);
        this.fixedBar = this.fixedBtn = null;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();

            this._syncFixedCta();
            this._observeSubmit();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      _getForm() {
        return this.querySelector('product-form form.form') ||
          this.querySelector('form[data-type="add-to-cart-form"]') ||
          this.querySelector('form');
      }

      _getSubmit() {
        return this.querySelector('#ProductSubmitButton-' + this.dataset.section) ||
          this.querySelector('[name="add"].product-form__submit') ||
          this.querySelector('[type="submit"]');
      }

      _getButtonsWrap() {
        const submit = this._getSubmit();
        return this.querySelector('.product-form__buttons') ||
          (submit && submit.closest('.product-form__buttons')) ||
          submit || this;
      }

      _initFixedAtc() {
        if (this.fixedBar) return;

        const sectionId = this.dataset.section;
        const formEl = this._getForm();
        const formId = formEl?.id || ('product-form-' + sectionId);

        const bar = document.createElement('div');
        bar.className = 'fixed-atc-' + sectionId;
        bar.hidden = true;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'button button--primary button--full-width';
        btn.setAttribute('data-fixed-atc-btn', '');
        btn.textContent = (this._getSubmit()?.textContent?.trim()) || 'Add to cart';
        bar.appendChild(btn);

        this.appendChild(bar);
        this.fixedBar = bar;
        this.fixedBtn = btn;

        this.fixedBtn.addEventListener('click', (e) => this._onFixedClick(e));

        this._syncFixedCta();
        this._observeSubmit();
        this._attachIO();
      }

      _onFixedClick(e) {
        const submit = this._getSubmit();
        if (!submit) {
          console.warn('[Fixed ATC] No main submit button found');
          return;
        }
        if (this.fixedBtn.disabled || submit.disabled) return;

        submit.click();
      }

      _syncFixedCta() {
        if (!this.fixedBtn) return;
        const mainSubmit = this._getSubmit();
        if (!mainSubmit) return;

        this.fixedBtn.disabled = !!mainSubmit.disabled;
        const label = mainSubmit.querySelector('span')?.textContent?.trim() || mainSubmit.textContent?.trim();
        if (label) this.fixedBtn.textContent = label;
      }

      _observeSubmit() {
        if (this._submitMo) this._submitMo.disconnect();
        const submit = this._getSubmit();
        if (!submit) return;
        this._submitMo = new MutationObserver(() => this._syncFixedCta());
        this._submitMo.observe(submit, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled','aria-busy'] });
      }

      _attachIO() {
        if (this._io) this._io.disconnect();

        const target = this._getButtonsWrap() || this._getSubmit();
        if (!target || !this.fixedBar) return;

        this._io = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) {
            this.fixedBar.hidden = false;
            this.fixedBar.classList.add('is-visible');
          } else {
            this.fixedBar.classList.remove('is-visible');
            setTimeout(() => {
              if (!this.fixedBar.classList.contains('is-visible')) this.fixedBar.hidden = true;
            }, 200);
          }
        }, {
          root: null,
          threshold: 0,
          rootMargin: '0px 0px 0px 0px'
        });

        this._io.observe(target);
      }
    }
  );
}
